import React, { Component } from "react";
import "./Header.css";
import spatiam_logo from "../assets/logo.png";
import spatiam_logo_title from "../assets/logo_title.png";

// es7 snippets - 'rfce'
class Header extends Component {
  state = {
    show_deployment: this.get_show_deployment("header_show") === "true",
  };

  get_show_deployment() {
    let value = `; ${document.cookie}`;
    let parts = value.split(`; header_show=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  toggle_show_deployment() {
    if (this.state.show_deployment) {
      document.cookie =
        "header_show = false;max-age=4320000;path=" + this.props.baseDir;
      this.setState({ show_deployment: false });
    } else {
      document.cookie =
        "header_show = true;max-age=4320000;path=" + this.props.baseDir;
      this.setState({ show_deployment: true });
    }
  }

  render() {
    return (
      <div className="header">
        <div className="header_image">
          <a href="https://www.spatiam.com/">
            <img className="header_logo" src={spatiam_logo} alt="logo" />
          </a>
          <a href="https://www.spatiam.com/">
            <img
              className="header_logo_title"
              src={spatiam_logo_title}
              alt="logo_title"
            />
          </a>
        </div>
        {this.state.show_deployment === true ? (
          <>
            {process.env.REACT_APP_MGR_DEP === "local" ? (
              <div className="header_title local">
                <p
                  onClick={() => {
                    this.toggle_show_deployment();
                  }}
                  className="header_title_local"
                >
                   LOC 
                </p>
              </div>
            ) : (
              <></>
            )}
            {process.env.REACT_APP_MGR_DEP === "development" ? (
              <div className="header_title local">
                <p
                  onClick={() => {
                    this.toggle_show_deployment();
                  }}
                  className="header_title_development"
                >
                   DEV 
                </p>
              </div>
            ) : (
              <></>
            )}
          </>
        ) : (
          <div
            className="header_title local"
            onClick={() => {
              this.toggle_show_deployment();
            }}
          ></div>
        )}
        <div className="logout_area">
          {this.props.demoMode ? (
            <p>
              User: <b>spatiam-user</b>
            </p>
          ) : (
            <p>
              User: <b>{this.props.user}</b>
            </p>
          )}
          <button
            className="logout_button"
            onClick={() => {
              this.props.removeCookie("spatiamtoken", {
                path: this.props.baseDir,
              });
              this.props.setToken(null);
            }}
          >
            Sign out
          </button>
        </div>
      </div>
    );
  }
}

// es5 snippets
export default Header;
